<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
       <el-form-item>
        <el-button type="primary" @click="openAdd">认购份额</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
     
    </auto-table>

     <AddorEdit ref="add" @success="getList(1)"></AddorEdit>
  </div>
</template>

<script>
import AddorEdit from './AddorEdit.vue';
export default {
  components:{
      AddorEdit
  },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "投资人", value: "investor_name" },
        { name: "认购份额", value: "shares" },
        { name: "认购金额", value: "investment_amount" },
        { name: "分成比例", value: "share_rate" },
        { name: "购买时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      load: false,
      manager: JSON.parse( localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.id = this.$route.query.id;
  },

  methods: {
     
    init() {
      if (!this.load) {
        this.load = true;
        this.getList(1);
      }
    },
    openAdd() {
      this.$refs.add.open();
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/packageInv/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          package_id: this.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>